<app-generic-table
    [data]="data"
    [cols]="tableCols"
    [scrollHeight]="'min(60vh, 32rem)'"
    [showNewButton]="false"
    [showAutoRefresh]="false"
    [showBasicPaginator]="false"
    [showPaginator]="false"
    [showFilterButton]="false"
    [showSearch]="false"
    [showRefreshButton]="false"
    [contextMenu]="this.menuItems"
    (contextMenuSelectEvent)="buildContextMenu($event)"
>
</app-generic-table>

<div class="p-dialog-footer">
    <p-button severity="contrast" icon="pi pi-times" type="button" label="Close" (onClick)="ref.close()" />
</div>
